// tailwindcss
import { loadableReady } from '@loadable/component';
import ReactDOM from 'react-dom';
import './src/styles/global.css';
import './src/styles/swiper.css';
import { OpenFeature } from '@openfeature/web-sdk';
import { DatadogProvider } from '@datadog/openfeature-browser';
import { DATADOG_APPLICATION_ID, DATADOG_CLIENT_TOKEN, DATADOG_ENV } from 'gatsby-env-variables';
import { captureAndStoreTrackingParams } from './src/utils';

export const replaceHydrateFunction = () => {
    return (element, container, callback) => {
        loadableReady(() => {
            ReactDOM.render(element, container, callback);
        });
    };
};

/**
 * Capture ad tracking params (msclkid, UTMs, gclid, etc.) from the URL on every
 * page load/navigation and persist them to localStorage (30-day expiry).
 * This enables cross-session attribution: if a user clicks a Bing ad, closes the
 * browser, then returns directly and fills out an application, the original
 * msclkid is still forwarded to the application subdomain.
 */
export const onRouteUpdate = () => {
    captureAndStoreTrackingParams();
};

// Updating Gatsby's default scroll behavior
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
    if (location.pathname === '/') {
        window.scrollTo(0, 0);
        return false; // false to prevent Gatsby's default scroll behavior
    }

    const savedPosition = getSavedScrollPosition(location);
    window.scrollTo(...(savedPosition || [0, 0]));

    return false; // false to prevent Gatsby's default scroll behavior
};

export const onClientEntry = async () => {
    if (DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN && DATADOG_ENV) {
        // provider initialisation can fail if the Datadog script hasn't loaded yet or is blocked, so we wrap in a try/catch to avoid breaking the app
        try {
            const provider = new DatadogProvider({
                applicationId: DATADOG_APPLICATION_ID,
                clientToken: DATADOG_CLIENT_TOKEN,
                site: 'datadoghq.eu',
                env: DATADOG_ENV,
            });
            await OpenFeature.setProviderAndWait(provider);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            // silently ignore error
        }
    }
};
